<template>
  <div class="contract-hotel-card-container">
    <div class="contract-hotel-card-image-container">
      <div
        v-if="transportationProvided"
        class="mobile-featured-bar"
      >
        {{ $t('h4h.featuredWithTransportation') }}
      </div>
      <div
        v-else
        class="mobile-featured-bar"
      >
        {{ $t('h4h.featured') }}
      </div>
      <ImageSlider
        :hotelid="parseInt(hotel.id)"
        :images="hotel.images"
      />
    </div>
    <div class="contract-hotel-details">
      <div class="contract-hotel-title">
        <h5>{{ hotel.name }}</h5>
      </div>
      <p>{{ hotel.fullAddress }}</p>
      <p v-if="hotel.directions">
        {{ hotel.directions.distance.text }} to {{ this.$store.state.hotel.venue }}
      </p>
    </div>
    <div class="contract-hotel-purchasing">
      <div class="contract-hotel-pricing">
        <span class="price ">
          <CurrencyConvert
            :amount="price / hotel.stayDuration"
            :currency="'USD'"
          />
        </span>
        <span>
          {{ $t('h4h.perNight') }}
        </span>
        <span class="dates">
          <CurrencyConvert
            :amount="price"
            :currency="'USD'"
          />
          {{ $t('h4h.contractedTotal', {
            checkIn: checkIn.slice(0,5),
            checkOut: checkOut.slice(0,5)
          }) }}
        </span>
      </div>
      <div class="contract-hotel-show-btn">
        <div
          class="btn btn-secondary room-select-btn"
          @click="selectSpecifiedHotel(hotel)"
        >
          {{ $t('h4h.chooseRoom') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
import ImageSlider from '../../image_slider'
import Hotel from '../../../classes/hotel'
import { CurrencyConvert } from '../../../default/currency_convert'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    ImageSlider,
    CurrencyConvert
  },
  props: {
    id: {
      default: null,
      type: Number
    },
    hotel: {
      default: null,
      type: Hotel
    }
  },

  computed: {
    ...mapGetters('hotel', [
      'getContractedCheckInDate',
      'getContractedCheckOutDate',
      'getLowestValue'
    ]),
    price() {
      return this.getLowestValue(this.hotel.id)
    },
    checkIn() {
      return this.getContractedCheckInDate
    },
    checkOut() {
      return this.getContractedCheckOutDate
    },
    transportationProvided(){
      return this.hotel.transportationFee > 0 ? true : false
    }
  },

  methods: {
    ...mapMutations('hotel', ['selectHotel', 'deselectHotel']),

    selectSpecifiedHotel(hotel){
      this.selectHotel(hotel)
      window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
      window.addEventListener('popstate', (e)=>{
        e.state !== null ? this.selectHotel(hotel) :this.selectHotel(null)
      })
    }
  }


}

</script>
